import { render, staticRenderFns } from "./AppliedFilters.vue?vue&type=template&id=5cd673fc&scoped=true&"
import script from "./AppliedFilters.vue?vue&type=script&lang=ts&"
export * from "./AppliedFilters.vue?vue&type=script&lang=ts&"
import style0 from "./AppliedFilters.vue?vue&type=style&index=0&id=5cd673fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd673fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VIcon,VRow})
